export default {
    SET_MAILCUSTOMER (state, subscriptions) {
        state.subscriptions = subscriptions
    },
    SET_INFO_DB(state, payload){
        state.infoDB = payload
    },
}